import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { routes } from "@/features/shared/navigation";
import { ReturnTypeFromAsyncLoader } from "@/types/return-type-from-async-loader";

import { pageQuery as pageQueryFn } from "./queries";

export const adminPageLoaderId = "admin-page";

export const pageLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    const page = await queryClient.ensureQueryData(pageQueryFn(String(params.page)));

    if (!page) {
      return redirect(routes.admin.dashboard_pages_overview);
    }

    return null;
  };

export type pageLoaderData = ReturnTypeFromAsyncLoader<typeof pageLoader>;
